module.exports = __webpack_public_path__ + "static/media/startintegration.ebdd899e.png";